import { render, staticRenderFns } from "./JiraVersionPicker.vue?vue&type=template&id=92197c38&scoped=true"
import script from "./JiraVersionPicker.vue?vue&type=script&lang=js"
export * from "./JiraVersionPicker.vue?vue&type=script&lang=js"
import style0 from "./JiraVersionPicker.vue?vue&type=style&index=0&id=92197c38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92197c38",
  null
  
)

export default component.exports